import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, TextField, Button, Alert, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { createCategory, getAccounts } from '../services/api';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '90%', sm: 400 },
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: { xs: 2, sm: 3, md: 4 },
  maxHeight: '90vh',
  overflowY: 'auto'
};

function AddCategoryModal({ open, handleClose, onCategoryAdded, accountId }) {
  const [categoryName, setCategoryName] = useState('');
  const [selectedAccount, setSelectedAccount] = useState(accountId || '');
  const [accounts, setAccounts] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    if (accountId) {
      setSelectedAccount(accountId);
    } else {
      const fetchAccounts = async () => {
        try {
          const accountsRes = await getAccounts();
          setAccounts(accountsRes.data);
        } catch (err) {
          console.error("Failed to fetch accounts", err);
          setError("Failed to load accounts.");
        }
      };
      if (open) {
        fetchAccounts();
      }
    }
  }, [open, accountId]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    try {
      if (!selectedAccount) {
        setError('Please select an account for the category.');
        return;
      }
      await createCategory(categoryName, selectedAccount);
      onCategoryAdded();
      handleClose();
      setCategoryName(''); // Clear form
      setSelectedAccount('');
    } catch (err) {
      console.error("Failed to add category", err);
      setError(err.response?.data?.msg || 'Failed to add category');
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} component="form" onSubmit={handleSubmit}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Add New Category
        </Typography>
        {error && <Alert severity="error" sx={{ mt: 2, mb: 2 }}>{error}</Alert>}
        <TextField
          margin="normal"
          required
          fullWidth
          label="Category Name"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          sx={{ 
            '& .MuiInputBase-input': { 
              fontSize: { xs: '16px', md: '14px' }
            }
          }}
        />
        {!accountId && (
          <FormControl fullWidth margin="normal" required>
            <InputLabel id="account-select-label">Account</InputLabel>
            <Select
              labelId="account-select-label"
              id="account-select"
              value={selectedAccount}
              label="Account"
              onChange={(e) => setSelectedAccount(e.target.value)}
            >
              {accounts.map((account) => (
                <MenuItem key={account.id} value={account.id}>
                  {account.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Add Category
        </Button>
        <Button
          fullWidth
          variant="outlined"
          onClick={handleClose}
        >
          Cancel
        </Button>
      </Box>
    </Modal>
  );
}

export default AddCategoryModal;
